<template>
  <NavbarV2 v-if="!isNotFoundPage && !isResumePage" />

  <router-view />
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import NavbarV2 from '@/components/NavbarV2.vue'
// import Navbar from '@/components/Navbar.vue' // Backup - versión original
import Footer from '@/components/Footer.vue'
import { useLenis } from '@/composables/useLenis'
import { useTheme } from '@/composables/useTheme'

const route = useRoute()

// Inicializar sistema de temas
const { initTheme, cleanup: cleanupTheme } = useTheme()

// Inicializar Lenis para smooth scrolling
useLenis()

// Computed property para detectar si estamos en la página 404
const isNotFoundPage = computed(() => {
  return route.name === 'not-found' || route.path === '/:pathMatch(.*)*'
})

// Computed property para detectar si estamos en la página de resume
const isResumePage = computed(() => {
  return route.name === 'resume'
})

// Inicializar tema al montar la app
onMounted(() => {
  initTheme()
})

// Limpiar listeners al desmontar
onUnmounted(() => {
  cleanupTheme()
})
</script>
